//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { Enums } from '../../../models/common/enums'
import { IOpObject, IReferenceType } from '../../../models/util/interfaces'
import { OpLocation } from '../../../models/core/op-location'

import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'

import { IUserSession } from '../../../helpers/user-session'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { EventsNames, ToastHelper } from '../../../helpers'

import { DataTypeGroupService } from '../../../services/data-type-group'
import { OpDataTypeGroup } from '../../../models/core'

interface DataTypeGroupCreateEditScope extends CreateEditScope {
}

export class DataTypeGroupCreateEditController extends CreateEditController {

    // Members

    private referenceValue: OpLocation

    // Members End

    //#region Ctor

    public constructor(
        private $scope: DataTypeGroupCreateEditScope,
        protected $q: ng.IQService,
        protected $timeout: ng.ITimeoutService,
        protected readonly userSession: IUserSession,
        private readonly dataTypeGroupService: DataTypeGroupService,
        private readonly moduleName: Enums.SimaxModuleName
    ) {
        super(DataTypeGroupService.REFERENCE_TYPE, moduleName, $scope, $timeout, $q)
    }

    //#endregion

    //#region CreateEditController Overrides

    protected onInitialize(createEditInitParams: CreateEditInitParams): void {
        this.referenceValue = createEditInitParams ? <OpLocation>createEditInitParams.referenceObject : null

        if (this.referenceValue && this.referenceValue.idObject > 0) {
            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
        } else {
            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
        }
        // ToastHelper.showWarning('Not implemented yet')
        super.openCreateEdit(createEditInitParams)
    }

    protected onSaving(objectToSave: IOpObject): JQueryPromise<IOpObject> {
        const defer: JQueryDeferred<IOpObject> = $.Deferred<IOpObject>()
        const dataTypeGroup: OpDataTypeGroup = OpDataTypeGroup.fromIOpObject(objectToSave)

        if (dataTypeGroup.idDataTypeGroupType == null) {
            dataTypeGroup.idDataTypeGroupType = 1
        }

        this.dataTypeGroupService
            .saveDataTypeGroup(dataTypeGroup)
            .then((savedObject: OpDataTypeGroup) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                defer.resolve(savedObject)
            })
            .fail((error: any) => {
                this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                defer.reject()
            })

        return defer.promise()
    }

    //#endregion    
}